<template>
    <div class="printContainer white">
        <tv-display-tab class="scale" :style="scaleStyle">
        </tv-display-tab>
    </div>
</template>

<script>
    import TvDisplayTab from "./tvDisplayTab";

    export default {
        components: {
            TvDisplayTab,},
        name: "tv-display",
        computed: {
            scaleRatio(){
                return this.breite / 1920
            },
            scaleStyle(){
                return 'transform: scale(' + this.scaleRatio + ');'
            },
        },
        data: () => ({
            breite: window.innerWidth,
        }),
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        methods: {
            onResize() {this.breite = window.innerWidth},
        },
    }
</script>

<style scoped>
    .scale {
        transform-origin: left top;
    }
</style>